import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const CheckWithSpace = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
  >
    <defs>
      <path
        id="check-with-space-a"
        d="M16.821 7.573a.667.667 0 011.074.786l-.05.068-6.666 8a.667.667 0 01-.81.17l-.072-.042-4-2.667a.667.667 0 01.672-1.149l.067.04 3.501 2.334 6.284-7.54z"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="check-with-space-b" fill={props.color || theme.palette.grey600}>
        <use xlinkHref="#check-with-space-a"></use>
      </mask>
      <use
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
        xlinkHref="#check-with-space-a"
      ></use>
      <g fill="#666" mask="url(#check-with-space-b)">
        <path d="M0 0h24v24H0z"></path>
      </g>
    </g>
  </svg>
);
